import { useState } from "react";
import BookNowModal from "./BookNowModal";

const BookNowButton = ({ buttonText, buttonClass,yachtId,yachtName }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Book Now Button */}
      <button className={buttonClass} onClick={() => setShowModal(true)}>
        {buttonText}
      </button>

      {/* Reusable Modal */}
      <BookNowModal show={showModal} handleClose={() => setShowModal(false)} yachtId={yachtId} yachtName={yachtName} />
    </>
  );
};

export default BookNowButton;
